import React from 'react';

const eventTypes = [
  'Wedding',
  'Birthday',
  'Corporate Event',
  'Conference',
  'Anniversary',
  'Baby Shower',
  'Graduation',
  'Product Launch',
  'Workshop',
  'Other'
];

const venueTypes = [
  'Hall',
  'Outdoor Garden',
  'Beachfront',
  'Rooftop',
  'Banquet Hall',
  'Hotel Conference Room',
  'Restaurant Private Dining',
  'Community Center',
  'Other'
];

const nigerianStates = [
  'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa', 'Benue', 'Borno',
  'Cross River', 'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu', 'FCT', 'Gombe',
  'Imo', 'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Kogi', 'Kwara',
  'Lagos', 'Nasarawa', 'Niger', 'Ogun', 'Ondo', 'Osun', 'Oyo', 'Plateau',
  'Rivers', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara'
];

function VenueRequestForm({ formData, setFormData }) {

  const today = new Date().toISOString().split("T")[0];

   const handleDateChange = (index, date) => {
    if (index === "eventDate")
      setFormData({
        ...formData,
        eventDate: date,
        startDate: null,
        endDate: null,
      });

    if (index === "startDate")
      setFormData({
        ...formData,
        eventDate: null,
        startDate: date,
      });

    if (index === "endDate") {
      setFormData({
        ...formData,
        eventDate: null,
        endDate: date,
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

   const handleSelectionChange = (e) => {
    const selection = e.target.value;

    if (selection === "single") {
      setFormData({
        ...formData,
        startDate: null,
        endDate: null,
        eventDuration: selection,
      });
    } else if (selection === "multiple") {
      setFormData({ ...formData, eventDate: null, eventDuration: selection });
    }
  };

  return (
    <div className="venue-form-container">
      <div className="form-holder ">
        <form>
          <div className="form-items required">
            <label className="form-label">Full Name</label>
            <input
              type="text"
              name="fullName"
              placeholder="Enter your full name"
              value={formData.fullName}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-items required">
            <label className="form-label">WhatsApp Number</label>
            <input
              type="tel"
              name="phone"
              placeholder="0801234567"
              value={formData.phone}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-items required">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="yourname@example.com"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-items required">
            <label className="form-label">Type of Event</label>
            <div className="dropdown">
              <select
                name="eventType"
                value={formData.eventType}
                onChange={handleInputChange}
                required
              >
                <option value="">Select event type</option>
                {eventTypes.map((type) => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
            </div>

            {formData?.eventType === "Other" && (
              <input
                className="mt-3"
                type="text"
                name="otherEventType"
                placeholder="Please Specify The Event Type"
                value={formData.otherEventType || ""}
                onChange={handleInputChange
                }
              />
            )}
          </div>

          {/* <div className="form-items required">
            <label className="form-label">Event Date</label>
            <input
              type="date"
              name="eventDate"
              value={formData.eventDate}
              onChange={handleInputChange}
              required
            />
          </div> */}

          <div className="form-items required">
            <label className="form-label">Event Duration</label>
            <>
              <div className="dropdown mb-4">
                <select
                  className="form-control"
                  value={formData.eventDuration}
                  onChange={handleSelectionChange}
                >
                  <option value="">Select Event Duration</option>
                  <option value="single">Single Date</option>
                  <option value="multiple">Multiple Days</option>
                </select>
              </div>
             
            </>
            {formData.eventDuration === "single" && (
              <>
                <div className="date-picker-wrapper">
                  <input
                    type="date"
                    id="eventDate"
                    name="eventDate"
                    min={today}
                    placeholder="Select A Date"
                    value={formData.eventDate || ""}
                    //   className={errors.eventDate ? "error-input" : ""}
                    className="custom-date-input"
                    onChange={(e) =>
                      handleDateChange("eventDate", e.target.value)
                    }
                  />
                </div>
              </>
            )}
            {formData.eventDuration === "multiple" && (
              <>
                <>
                  <div className="form-items ">
                    <label className="form-label">Start Date</label>
                    <input
                      type="date"
                      id="startDate"
                      name="startDate"
                      min={today}
                      value={formData.startDate || ""}
                      //   className={errors.eventDate ? "error-input" : ""}
                      className="custom-date-input"
                      onChange={(e) =>
                        handleDateChange("startDate", e.target.value)
                      }
                    />
                  </div>
                  
                </>
                <>
                  <div className="form-items ">
                    <label className="form-label">End Date</label>
                    <input
                      type="date"
                      id="endDate"
                      name="endDate"
                      min={today}
                      value={formData.endDate || ""}
                      //   className={errors.eventDate ? "error-input" : ""}
                      className="custom-date-input"
                      onChange={(e) =>
                        handleDateChange("endDate", e.target.value)
                      }
                    />
                  </div>
                  {/* {errors.endDate && (
                    <span className="error-text m-0">{errors.endDate}</span>
                  )} */}
                </>
              </>
            )}
          </div>

          <div className="form-items required">
            <label className="form-label">Estimated Guest Capacity</label>
            <input
              type="number"
              name="guestCapacity"
              placeholder="e.g. 100"
              value={formData.guestCapacity}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-items required">
            <label className="form-label">Venue Type</label>
            <div className="dropdown">
              <select
                name="venueType"
                value={formData.venueType}
                onChange={handleInputChange}
                required
              >
                <option value="">Select venue type</option>
                {venueTypes.map((type) => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-items required">
            <label className="form-label">Preferred State</label>
            <div className="dropdown">
              <select
                name="preferredState"
                value={formData.preferredState}
                onChange={handleInputChange}
                required
              >
                <option value="">Select state</option>
                {nigerianStates.map((state) => (
                  <option key={state} value={state}>{state}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-items required">
            <label className="form-label">Preferred Area/Location</label>
            <input
              type="text"
              name="preferredArea"
              placeholder="e.g. Victoria Island, Ikeja, etc."
              value={formData.preferredArea}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-items">
            <label className="form-label">Additional Details or Preferences (Optional)</label>
            <textarea
              name="additionalDetails"
              placeholder="Any specific requirements, preferences, or additional information..."
              value={formData.additionalDetails}
              onChange={handleInputChange}
              rows="4"
              style={{
                width: '100%',
                padding: '1.1rem 2.2rem',
                borderRadius: '1.4rem',
                border: 'none',
                fontSize: 'clamp(1.4rem, 2vw, 1.8rem)',
                backgroundColor: '#fff',
                boxShadow: '0 2px 10px #00000011',
                outline: 'none',
                resize: 'vertical',
                fontFamily: 'inherit'
              }}
            />
          </div>

          <div className="form-items ">
            <label className="form-label d-flex  gap-3">
              <input
                type="checkbox"
                name="agreeToFee"
                checked={formData.agreeToFee}
                onChange={handleInputChange}
                className="radio-input"
                required
              />
              <span className="check-label">
                I understand the ₦10,000 consultation fee is non-refundable.
              </span>
            </label>
          </div>

          <p className='sub-para'>
            After payment, you’ll receive a confirmation email, and within 2  business days, our support team will share curated venue options that perfectly match your request via whatsapp and email.
          </p>
        </form>
      </div>
    </div>
  );
}

export default VenueRequestForm;